import React, { ReactElement } from 'react';

export default function Bricks(props: {
    className?: string;
}): ReactElement {
    const { className } = props;

    return (
        <svg className={className} fill='none' height='64' stroke='currentColor' viewBox='0 0 64 64' width='64' xmlns='http://www.w3.org/2000/svg'>
            <rect height='8' width='18' x='13.5' y='8.5' />
            <rect height='8' width='18' x='13.5' y='24.5' />
            <rect height='8' width='18' x='13.5' y='40.5' />
            <rect height='8' width='18' x='4.5' y='16.5' />
            <rect height='8' width='18' x='4.5' y='32.5' />
            <rect height='8' width='18' x='4.5' y='48.5' />
            <rect height='8' width='18' x='31.5' y='8.5' />
            <rect height='8' width='18' x='31.5' y='24.5' />
            <rect height='8' width='18' x='31.5' y='40.5' />
            <rect height='8' width='19' x='22.5' y='16.5' />
            <rect height='8' width='19' x='22.5' y='32.5' />
            <rect height='8' width='19' x='22.5' y='48.5' />
            <rect height='8' width='18' x='41.5' y='16.5' />
            <rect height='8' width='18' x='41.5' y='32.5' />
            <rect height='8' width='18' x='41.5' y='48.5' />
        </svg>
    );
}